import { Typography } from 'antd';
import Images from 'app/assets/img';
import { StyledStack } from 'app/components/Stack';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import React from 'react';
import { useSelector } from 'react-redux';

const DownLoadExcel = ({ disabled, onClick }) => {
  const translations = useSelector(selectTranslations);

  return (
    <div style={{ display: 'grid', alignItems: 'center' }}>
      <StyledStack
        onClick={e => (disabled ? e.preventDefault() : onClick && onClick())}
        display={{ lg: 'flex', md: 'none' }}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        columnGap={'8px'}
        alignItem={'center'}
      >
        <img
          alt="ExportTicketIcon"
          src={Images.ExportTicketIcon}
          width={20}
          height={20}
          style={{
            filter: disabled ? 'contrast(0)' : 'none',
          }}
        />
        <Typography
          style={{
            color: disabled ? '#808080' : '#FAB317',
            fontSize: 14,
            textWrap: 'nowrap',
          }}
        >
          {translations?.['b2b.txt.export-excel']}
        </Typography>
      </StyledStack>
    </div>
  );
};

export default DownLoadExcel;
